import { useInfiniteQuery } from '@tanstack/react-query';
import { queryKeys } from '../lib/queryKeys';
import { fetchLeadsByStatus } from '../api/leads';

const ITEMS_PER_PAGE = 30;

/**
 * Infinite-scroll query for kanban column leads.
 * Returns pages of leads that can be flattened: data.pages.flatMap(p => p.leads)
 */
export function useKanbanLeads (statusId, { search, managerFilter, statusIn, lastContactDays } = {}) {
  return useInfiniteQuery({
    queryKey: queryKeys.leads.column(statusId, search, managerFilter, statusIn, lastContactDays),
    queryFn: ({ pageParam = 1 }) =>
      fetchLeadsByStatus({
        statusId,
        page: pageParam,
        limit: ITEMS_PER_PAGE,
        search,
        managerFilter,
        statusIn,
        lastContactDays,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      const currentPage = allPages.length;
      const totalPages = lastPage.pagination?.totalPages || 1;
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    staleTime: 60_000,
    enabled: Boolean(statusId),
  });
}
